import styled from "styled-components";


const AboutStyleWrapper = styled.section`
  padding: 110px 0;
  background: #0d102d;

  p {
    margin-bottom: 0;
  }

  /* right */
  .v1_about_us_right_text {
    margin-top: 46px;

    p {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: rgba(255, 255, 255, 0.8);
      padding-bottom: 20px;
    }
  }

  /* list */

  .about_us_text_card_sect {
    margin-top: 120px;
  }
    .about_us_text_card {
      background: #131740;
      width: 100%;
      min-height: 220px;
      padding: 35px;

      h3 {
        font-family: "Poppins";
        font-style: normal;
        font-weight: 400;
        font-size: 24px;
        line-height: 40px;
        color: #ffffff;

        img {
          padding-right: 10px;
        }

        span {
          margin-right: 13px;
        }
      }

      p {
        font-family: "Poppins";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        max-width: 289px;
        color: rgba(255, 255, 255, 0.8);
        padding-top: 18px;
      }
    }

  .image_section{
    position: relative;
  }

  @keyframes coin {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0);
    }
  }
  
  .coin_img{
    position: absolute;
    right: 224px;
    top: 183px;
    animation: coin 2s infinite;
  }

  .learmore_btn{
    background: transparent;
  }

  @media only screen and (max-width: 1400px) {
    .coin_img{
      right: 140px;
    }
  }

  @media only screen and (max-width: 1199px) {
    .v1_about_us_right_text {
      margin-top: 30px;
    }

    .coin_img{
      right: 100px;
    }
  }

  @media only screen and (min-width: 992px) and (max-width: 1199px) {

    .about_us_text_card {
      h3 {
        font-size: 20px;
        line-height: 40px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        span {
          max-width: 40px;
        }
      }
    }
  }

  @media only screen and (max-width: 991px) {
    padding-top: 65px;

    .about_us_text_card_sect {
      margin-top: 60px;

      &.md-mt-0 {
        margin-top: 0;
      }
    }

    .image_section{
      margin-top: 30px;
    }

    .coin_img{
      right: 280px;
    }

    .learmore_btn{
      margin-top: 20px;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 991px) {

    .about_us_text_card {
      padding: 27px;
      h3 {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        font-size: 20px;
      }
    }
  }

  @media only screen and (max-width: 767px) {

    .about_us_text_card {
      margin-bottom: 30px;

      p {
        max-width: 100%;
      }
    }
  }

  @media only screen and (max-width: 575px) {
    padding : 80px 0;

    .v1_about_us_right_text {
      margin-top: 10px;
      p {
        font-size: 13px;
        line-height: 24px;
        padding-bottom: 10px;
      }
    }

    .coin_img{
      right: 80px;
      height: 100px;
      width: 100px;
    }
  }

  @media (max-width: 375px) {
    padding: 60px 0;

    .about_us_text_card {
      h3 {
        font-size: 20px;
        line-height: 40px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        span {
          max-width: 40px;
        }
      }
    }
    
    .coin_img{
      right: 60px;
      height: 70px;
      width: 70px;
      top: 130px;
    }
  }
`;

export default AboutStyleWrapper;
